document.addEventListener('DOMContentLoaded', () => {
  const cartDrawerR = document.querySelector('cart-drawer');

  if (!customElements.get('product-form')) {
    customElements.define('product-form', class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.cart = cartDrawerR || document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (this.form) {
          this.setupForm();
        }

        if (this.cart || cartDrawerR) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }
      }

      setupForm() {
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        try {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');

          if (this.querySelector('.loading-overlay__spinner')) {
            this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
          }

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          const response = await fetch(`${routes.cart_add_url}`, config);
          const responseData = await response.json();

          if (responseData.status) {
            this.handleErrorMessage(responseData.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (soldOutMessage) {
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
            }
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
          } else {
            this.handleSuccessfulSubmission(responseData);
          }
        } catch (error) {
          console.error(error);
        } finally {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }
          if (!this.error) {
            this.submitButton.removeAttribute('aria-disabled');
          }
          if (this.querySelector('.loading-overlay__spinner')) {
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          }
        }
      }

      handleErrorMessage(errorMessage = false) {
        const errorMessageWrapper = this.querySelector('.product-form__error-message-wrapper');
        if (errorMessageWrapper) {
          const errorMessageElement = errorMessageWrapper.querySelector('.product-form__error-message');
          errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
          if (errorMessage) {
            errorMessageElement.textContent = errorMessage;
          }
        }
      }

      handleSuccessfulSubmission(response) {
        this.error = false;
        const quickAddModal = this.closest('quick-add-modal');

        if (quickAddModal) {
          document.body.addEventListener('modalClosed', () => {
            setTimeout(() => {
              this.cart.renderContents(response);
              realCount();
              setTimeout(async () => {
    const languageNow = document.querySelector('.header__lang-current').textContent;
    const trimmedLanguageNow = languageNow.trim();
    
    let url;

    switch (trimmedLanguageNow) {
        case 'FR':
            url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/FR_reworked_10da3f31-fe31-4eff-88e1-195b6b8f5117.json?v=1703053371';
            break;
        case 'DE':
            url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/DE_reworked_8701a2f1-6a7e-47ad-90a7-1ad0059604d7.json?v=1703053371';
            break;
        case 'RU':
            url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/RU_reworked_74779b34-6f7a-446f-a0c9-b96ebaac6629.json?v=1703053371';
            break;
        case 'IT':
            url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/IT_reworked_3_9e4f39a7-1ff5-428f-bd6f-efac51e4825b.json?v=1703053370';
            break;
        case 'CN':
            url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/CN_reworked_43a655ec-c7da-4c6b-9e0d-55a15e4c7f70.json?v=1703053371';
            break;
        default:
            break;
    }

    if (url) {
        const response = await fetch(url);
        const data = await response.json();
        TranslationDrawer(data);
    }
});
            });
          }, { once: true });
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(response);
          realCount();
          setTimeout(async () => {
    const languageNow = document.querySelector('.header__lang-current').textContent;
    const trimmedLanguageNow = languageNow.trim();
    
    let url;

    switch (trimmedLanguageNow) {
        case 'FR':
            url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/FR_reworked_10da3f31-fe31-4eff-88e1-195b6b8f5117.json?v=1703053371';
            break;
        case 'DE':
            url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/DE_reworked_8701a2f1-6a7e-47ad-90a7-1ad0059604d7.json?v=1703053371';
            break;
        case 'RU':
            url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/RU_reworked_74779b34-6f7a-446f-a0c9-b96ebaac6629.json?v=1703053371';
            break;
        case 'IT':
            url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/IT_reworked_3_9e4f39a7-1ff5-428f-bd6f-efac51e4825b.json?v=1703053370';
            break;
        case 'CN':
            url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/CN_reworked_43a655ec-c7da-4c6b-9e0d-55a15e4c7f70.json?v=1703053371';
            break;
        default:
            break;
    }

    if (url) {
        const response = await fetch(url);
        const data = await response.json();
        TranslationDrawer(data);
        TranslationFormButtons(data);
    }
});
        }
      }
    });
  }
});
